import { useCallback, useEffect, useMemo, useState } from 'react';
import { opportunitiesServices } from 'shared/services/opportunitiesServices';

const { getProjectRoles } = opportunitiesServices();
export const useOpportunityPublicData = () => {
  const [complete, setComplete] = useState(false);
  const [projectId, setprojectId] = useState('');
  const [roleIds, setRoleIds] = useState<string[]>([]);
  const {
    data,
    isLoading: projectRolesLoading,
    hasNextPage,
    isFetchingNextPage: projectRolesRefetching,
    fetchNextPage,
  } = getProjectRoles(
    {
      // project_ids: [projectId],
      // except_role_ids: roleIds,
      project_slugs: [projectId],
      except_role_slugs: roleIds,
    },
    complete,
    {
      enabled: !!projectId,
    },
  );

  const projectRolesData = useMemo(() => {
    return data
      ? [].concat(...data.pages.map((page: any) => page.data.casting_role_opportunities_connection.nodes))
      : [];
  }, [data]);

  const fetchMoreProjectRoles = useCallback(() => {
    if (hasNextPage && !projectRolesRefetching) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage, projectRolesRefetching]);

  const getProjectRolesData = useCallback((projectId: string, complete: boolean, roleIds?: string[]) => {
    setComplete(complete);
    setprojectId(projectId);
    if (roleIds?.length) setRoleIds(roleIds as string[]);
  }, []);

  useEffect(() => {
    //staggered fetching
    if (projectRolesData.length < 2 && hasNextPage) {
      fetchMoreProjectRoles();
    }
  }, [projectRolesData, hasNextPage, fetchMoreProjectRoles]);

  return {
    projectRolesData,
    projectRolesLoading,
    fetchMoreProjectRoles,
    projectRolesRefetching,
    getProjectRolesData,
  };
};
